module.exports = __webpack_public_path__ + "static/media/app-store-badge.1b659262.svg";